// Absolute hrefs so links route correctly from any page (e.g. /legal/*),
// not just the landing page. Section anchors are prefixed with "/" so they
// navigate home first.
const linkHrefs: Record<string, string> = {
  'How It Works': '/#how-it-works',
  'Supported Services': '/#services',
  Pricing: '/#country-pricing',
  'API Docs': '/',
  Changelog: '/',
  'Privacy Policy': '/legal/privacy-policy',
  'Terms of Use': '/legal/terms-of-use',
  Contact: '/support',
}

export function Footer() {
  const links = {
    Product: [
      'How It Works',
      'Supported Services',
      'Pricing',
      'API Docs',
      'Changelog',
    ],
    Legal: ['Privacy Policy', 'Terms of Use', 'Contact'],
  }

  return (
    <footer
      style={{
        background: '#F8FAFF',
        borderTop: '1px solid #E5E7EB',
        padding: '80px 24px 40px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '48px',
            marginBottom: '64px',
          }}
        >
          {/* Brand column */}
          <div style={{ gridColumn: 'span 1' }}>
            <a
              href="/"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '16px',
              }}
            >
              <img
                src="/favicon.png"
                alt="GetCode"
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(59,130,246,0.3)',
                }}
              />
              <span
                style={{
                  fontWeight: '800',
                  fontSize: '18px',
                  color: '#111827',
                }}
              >
                GetCode
              </span>
            </a>
            <p
              style={{
                fontSize: '14px',
                color: '#6B7280',
                lineHeight: '1.65',
                margin: '0 0 20px',
                maxWidth: '200px',
              }}
            >
              Privacy-first virtual phone numbers for SMS verification
              worldwide.
            </p>

          </div>

          {/* Link columns */}
          {Object.entries(links).map(([category, items]) => (
            <div key={category}>
              <h4
                style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#111827',
                  margin: '0 0 16px',
                  letterSpacing: '0.8px',
                  textTransform: 'uppercase',
                }}
              >
                {category}
              </h4>
              {items.map((item) => (
                <a
                  key={item}
                  href={linkHrefs[item] ?? '/'}
                  style={{
                    display: 'block',
                    fontSize: '14px',
                    color: '#6B7280',
                    textDecoration: 'none',
                    marginBottom: '10px',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#3B82F6'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#6B7280'
                  }}
                >
                  {item}
                </a>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          style={{
            borderTop: '1px solid #E5E7EB',
            paddingTop: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          <p style={{ fontSize: '13px', color: '#9CA3AF', margin: 0 }}>
            © 2024 GetCode. All rights reserved. Virtual numbers for
            verification purposes only.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            {[
              { label: 'Privacy', href: '/legal/privacy-policy' },
              { label: 'Terms', href: '/legal/terms-of-use' },
            ].map(({ label, href }) => (
              <a
                key={label}
                href={href}
                style={{
                  fontSize: '13px',
                  color: '#9CA3AF',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#3B82F6'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#9CA3AF'
                }}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
